module.exports = __webpack_public_path__ + "flyer_background_confetti_toss_082-c924a35b93533d2dfcdc57fbe738f780.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_confetti_toss_082.jpg
// module id = 1628
// module chunks = 1